/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { I18n } from '@coze-arch/i18n';
import { isAbrRebrandEnabled } from '@coze-studio/abr-brand';

import zhCN from './locales/zh-CN.json';
import en from './locales/en.json';

const LOCALE_OVERRIDES: Record<string, Record<string, string>> = {
  'zh-CN': zhCN,
  en,
};

export function applyAbrI18nOverrides(): void {
  if (!isAbrRebrandEnabled()) {
    return;
  }

  for (const [lng, resources] of Object.entries(LOCALE_OVERRIDES)) {
    I18n.addResourceBundle(lng, 'i18n', resources, true, true);
  }
}
